import Country from "./slm/Country";
import { simplemaps_worldmap_mapdata } from "../includes/assets/mapdata.js";
import { DATA_RECEIVED_EVENT_KEY, SVG_NS } from "./constants";
import "./slm/slm-table";

(function ($) {
  // ============================= Countries cache and global variables ============================= //

  const countriesCache = new Map();
  let selectedCountry = null;

  // ============================= Fecth Country information ============================= //

  async function getCountryInformation(countryName) {
    if (!countriesCache.has(countryName)) return;
    const country = countriesCache.get(countryName);

    // try {
    country.setFetchingData(true);

    const ajaxUrl = siteConfig?.ajaxUrl ?? "";
    const ajaxNonce = siteConfig?.ajaxNonce ?? "";

    $.ajax({
      url: ajaxUrl,
      type: "post",
      data: {
        action: "country_data",
        ajax_nonce: ajaxNonce,
        country: countryName,
      },
      success: (response) => {
        if (!response || response?.success === false)
          return country.updateInformation();
        const parsedResponse = JSON.parse(response);
        country.updateInformation(parsedResponse);
      },
      error: (error) => {
        console.error(error);
        country.setFetchingData(false);
      },
    });
  }

  // ============================= Create html popup ============================= //

  function createAndAppendElement({
    parentElement,
    tag = "div",
    content,
    attributes,
    classList,
  }) {
    if (!parentElement || content === undefined) return;

    const newElement = document.createElement(tag);

    newElement.innerHTML = content;
    if (attributes && Array.isArray(attributes) && attributes.length > 0) {
      attributes.forEach((attr) => {
        newElement.setAttribute(attr.key, attr.value);
      });
    }
    if (classList && Array.isArray(classList) && classList.length > 0) {
      classList.forEach((className) => {
        newElement.classList.add(className);
      });
    }
    parentElement.appendChild(newElement);
    return newElement;
  }

  function renderPopup(country, countriesPaths) {
    const selectedCountryElement = document.querySelector("#selected-country");
    if (!selectedCountryElement) return;
    selectedCountryElement.innerHTML = "";
    const paths = [...countriesPaths].filter(
      (c) =>
        simplemaps_worldmap_mapdata?.state_specific?.[
          c.getAttribute("data-country-code")
        ]?.name === country.name,
    );

    let svgMap;

    if (paths?.length > 0) {
      svgMap = document.createElementNS(SVG_NS, "svg");
      svgMap.classList.add("subdivisions-map");
      svgMap.setAttribute("preserveAspectRatio", "xMidYMid meet");

      // Group all paths
      const group = document.createElementNS(SVG_NS, "g");

      paths.forEach((path) => {
        const cloned = path.cloneNode();
        group.appendChild(cloned);
      });

      svgMap.appendChild(group);
      selectedCountryElement.appendChild(svgMap);

      // To calculate viewBox, we need to append temporarily
      const tempSvg = document.createElementNS(SVG_NS, "svg");
      tempSvg.style.position = "absolute";
      tempSvg.style.visibility = "hidden";
      tempSvg.style.width = 0;
      tempSvg.style.height = 0;
      tempSvg.appendChild(group.cloneNode(true)); // clone group to tempSvg
      document.body.appendChild(tempSvg);

      const groupBBox = tempSvg.firstChild.getBBox(); // use the <g>'s bounding box
      document.body.removeChild(tempSvg);

      const padding = 10;
      svgMap.setAttribute(
        "viewBox",
        `${groupBBox.x - padding} ${groupBBox.y - padding} ${groupBBox.width + 2 * padding} ${groupBBox.height + 2 * padding}`,
      );
    }

    createAndAppendElement({
      parentElement: selectedCountryElement,
      content: country.name === "Europe" ? "Europe (ex-EU)" : country.name,
      classList: ["country-name"],
    });

    if (country.fetchingData) {
      createAndAppendElement({
        parentElement: selectedCountryElement,
        content: "",
        classList: ["loader"],
      });
    } else {
      if (country.entities?.length === 0) {
        createAndAppendElement({
          parentElement: selectedCountryElement,
          content: "There are no entities in our research for this country",
          classList: ["country-no-entities"],
        });
      } else {
        if (country.avg_score !== undefined) {
          let color = "";
          if (country.avg_score < 20) {
            color = "red";
          } else if (country.avg_score < 40) {
            color = "orange";
          } else if (country.avg_score < 60) {
            color = "yellow";
          } else if (country.avg_score < 80) {
            color = "light-green";
          } else if (country.avg_score >= 100) {
            color = "green";
          }
          svgMap?.setAttribute("data-color", color);
          const scoreElement = createAndAppendElement({
            parentElement: selectedCountryElement,
            content: "",
            classList: ["country-score"],
          });

          createAndAppendElement({
            parentElement: scoreElement,
            content: `${country.is_region ? "Region" : "Country"} Average Score: `,
            classList: ["country-score-title"],
            tag: "span",
          });
          createAndAppendElement({
            parentElement: scoreElement,
            content: country.avg_score,
          });
        }
        createAndAppendElement({
          parentElement: selectedCountryElement,
          content: `${country.companies?.length} Compan${country.companies?.length === 1 ? "y" : "ies"} | ${
            country.influencers?.length
          } Industry Association${country.influencers?.length === 1 ? "" : "s"}`,
          classList: ["country-entities"],
        });
        const currentPath = window.location?.pathname;
        createAndAppendElement({
          parentElement: selectedCountryElement,
          content: "Click to learn more",
          tag: "a",
          classList: ["learn-more-btn"],
          attributes: [
            {
              key: "href",
              value: `${currentPath}${currentPath?.endsWith("/") ? "" : "/"}?tab=table&custom_filters=region:${country.db_id}`,
            },
          ],
        });
      }
    }
  }

  function makeMapInteractive(mapElement, countries) {
    if (!mapElement) return;

    const countryNameElement = document.querySelector("#country-name");
    const selectedCountryElement = document.querySelector("#selected-country");

    selectedCountryElement.addEventListener("click", (ev) =>
      ev.stopPropagation(),
    );
    selectedCountryElement.addEventListener("touchend", (ev) =>
      ev.stopPropagation(),
    );

    let isMapBeingDragged = false;
    let startX, startY;
    let [viewBoxX, viewBoxY, viewBoxWidth, viewBoxHeight] = mapElement
      ?.getAttribute("viewBox")
      .split(" ")
      .map(Number); // Access the current viewBox
    let startDragViewBoxX = viewBoxX,
      startDragViewBoxY = viewBoxY;

    const MAP_LIMITS = {
      xStart: 0,
      yStart: -50,
      xEnd: 1000,
      yEnd: 400,
      minZoom: 40,
      maxZoom: 900,
    };

    function handleZoomMap(event) {
      event.preventDefault();

      let scale = event.deltaY / 1000;
      scale =
        Math.abs(scale) < 0.1
          ? (0.1 * event.deltaY) / Math.abs(event.deltaY)
          : scale;

      let pt = new DOMPoint(event.clientX, event.clientY);
      pt = pt.matrixTransform(mapElement.getScreenCTM().inverse());

      let [x, y, width, height] = mapElement
        .getAttribute("viewBox")
        .split(" ")
        .map(Number);

      if (
        width + width * scale <= MAP_LIMITS.minZoom ||
        width + width * scale >= MAP_LIMITS.maxZoom
      )
        return;

      let [xPropW, yPropH] = [(pt.x - x) / width, (pt.y - y) / height];

      let [width2, height2] = [width + width * scale, height + height * scale];
      let x2 = pt.x - xPropW * width2;
      let y2 = pt.y - yPropH * height2;

      // Constrain zooming beyond limits
      if (x2 < MAP_LIMITS.xStart) x2 = MAP_LIMITS.xStart;
      if (y2 < MAP_LIMITS.yStart) y2 = MAP_LIMITS.yStart;
      if (x2 + width2 > MAP_LIMITS.xEnd) x2 = MAP_LIMITS.xEnd - width2;
      if (y2 + height2 > MAP_LIMITS.yEnd) y2 = MAP_LIMITS.yEnd - height2;

      const someNaN = [x2, y2, width2, height2].some((value) => isNaN(value));

      if (!someNaN) {
        viewBoxX = x2;
        viewBoxY = y2;
        viewBoxWidth = width2;
        viewBoxHeight = height2;
        mapElement.setAttribute("viewBox", `${x2} ${y2} ${width2} ${height2}`);
      }
    }

    function handleGrabMap(event) {
      mapElement.classList.add("moving");
      isMapBeingDragged = true;
      startX = event.clientX;
      startY = event.clientY;
      startDragViewBoxX = viewBoxX;
      startDragViewBoxY = viewBoxY;
    }

    function handleDropMap() {
      mapElement.classList.remove("moving");
      isMapBeingDragged = false;
    }

    function handleMoveMap(event) {
      if (!isMapBeingDragged) return;

      const dx =
        (event.clientX - startX) * (viewBoxWidth / mapElement.clientWidth);
      const dy =
        (event.clientY - startY) * (viewBoxHeight / mapElement.clientHeight);

      let newViewBoxX = startDragViewBoxX - dx;
      let newViewBoxY = startDragViewBoxY - dy;

      // Ensure we don't move past the left or top boundaries
      if (newViewBoxX < MAP_LIMITS.xStart) newViewBoxX = MAP_LIMITS.xStart;
      if (newViewBoxY < MAP_LIMITS.yStart) newViewBoxY = MAP_LIMITS.yStart;

      // Ensure we don't move past the right or bottom boundaries
      if (newViewBoxX + viewBoxWidth > MAP_LIMITS.xEnd)
        newViewBoxX = MAP_LIMITS.xEnd - viewBoxWidth;
      if (newViewBoxY + viewBoxHeight > MAP_LIMITS.yEnd)
        newViewBoxY = MAP_LIMITS.yEnd - viewBoxHeight;

      const someNaN = [
        newViewBoxX,
        newViewBoxY,
        viewBoxWidth,
        viewBoxHeight,
      ].some((value) => isNaN(value));

      if (!someNaN) {
        viewBoxX = newViewBoxX;
        viewBoxY = newViewBoxY;
        mapElement.setAttribute(
          "viewBox",
          `${viewBoxX} ${viewBoxY} ${viewBoxWidth} ${viewBoxHeight}`,
        );
      }
    }

    mapElement.addEventListener("wheel", handleZoomMap);
    mapElement.addEventListener("mousedown", handleGrabMap);
    mapElement.addEventListener("mouseup", handleDropMap);
    mapElement.addEventListener("mouseleave", handleDropMap);
    mapElement.addEventListener("mousemove", handleMoveMap);

    document.addEventListener("mousemove", (ev) => {
      if (!countries.includes(ev.target) || isMapBeingDragged) {
        countryNameElement.innerText = "";
        countryNameElement.style.display = "none";
        return;
      }
      let country = new Country();
      const countryId = ev.target.getAttribute("data-country-code");
      const countryName =
        simplemaps_worldmap_mapdata?.state_specific?.[countryId]?.name;

      // Show country name on hover and fetch data if not in cache
      if (countriesCache.has(countryName)) {
        country = countriesCache.get(countryName);
      } else {
        countriesCache.set(
          countryName,
          new Country({
            name: countryName,
            id: countryId,
          }),
        );
        getCountryInformation(countryName);
      }

      if (!selectedCountry) {
        countryNameElement.style.display = "block";
        countryNameElement.innerText = country.name;

        const mouseX = ev.clientX;
        const mouseY = ev.clientY;
        const coords = calculateBoxPosition(mouseX, mouseY, mapElement);

        // Apply the calculated coordinates to the country name tag
        countryNameElement.style.top = coords.top;
        countryNameElement.style.right = coords.right;
        countryNameElement.style.bottom = coords.bottom;
        countryNameElement.style.left = coords.left;
      }
    });

    document.addEventListener("click", (ev) => {
      if (
        (!$("[data-global-region]").get().includes(ev.target) &&
          !countries.includes(ev.target)) ||
        isMapBeingDragged
      ) {
        $("[data-global-region]").removeClass("active");
        selectedCountry = null;
        selectedCountryElement.style.display = "none";
        selectedCountryElement.innerHTML = "";
        return;
      } else if (countries.includes(ev.target) && !isMapBeingDragged) {
        const countryId = ev.target.getAttribute("data-country-code");
        const countryName =
          simplemaps_worldmap_mapdata?.state_specific?.[countryId]?.name;

        if (!countriesCache.has(countryName)) return;
        selectedCountry = countriesCache.get(countryName);

        const winWidth = $(window).width();

        selectedCountryElement.style.display = "block";

        // Display popup with country information on click
        const mouseX = ev.clientX;
        const mouseY = ev.clientY;
        const coords = calculateBoxPosition(mouseX, mouseY, mapElement);
        selectedCountryElement.style.position =
          winWidth < 767 ? "absolute" : "fixed";
        selectedCountryElement.style.top = winWidth < 767 ? "auto" : coords.top;
        selectedCountryElement.style.right =
          winWidth < 767 ? "auto" : coords.right;
        selectedCountryElement.style.bottom =
          winWidth < 767 ? "76px" : coords.bottom;
        selectedCountryElement.style.left =
          winWidth < 767 ? "16px" : coords.left;
        selectedCountryElement.style.transform = "translate(0)";

        renderPopup(selectedCountry, countries);
      }
    });

    /** ================== Touch screens ========================= */

    // Touch zoom variables
    let initialDistance = null;
    let initialViewBox = null;

    function handleTouchStart(event) {
      if (event.touches.length === 1) {
        // Single touch - start drag
        mapElement.classList.add("moving");
        isMapBeingDragged = true;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        startDragViewBoxX = viewBoxX;
        startDragViewBoxY = viewBoxY;
      } else if (event.touches.length === 2) {
        // Two touches - start zoom
        event.preventDefault();
        initialDistance = getDistance(
          event.touches[0].clientX,
          event.touches[0].clientY,
          event.touches[1].clientX,
          event.touches[1].clientY,
        );
        initialViewBox = mapElement
          .getAttribute("viewBox")
          .split(" ")
          .map(Number);
      }
    }

    function handleTouchMove(event) {
      if (isMapBeingDragged && event.touches.length === 1) {
        // Single touch move - continue drag
        const dx =
          (event.touches[0].clientX - startX) *
          (viewBoxWidth / mapElement.clientWidth);
        const dy =
          (event.touches[0].clientY - startY) *
          (viewBoxHeight / mapElement.clientHeight);

        let newViewBoxX = startDragViewBoxX - dx;
        let newViewBoxY = startDragViewBoxY - dy;

        // Boundary checks (same as mouse version)
        if (newViewBoxX < MAP_LIMITS.xStart) newViewBoxX = MAP_LIMITS.xStart;
        if (newViewBoxY < MAP_LIMITS.yStart) newViewBoxY = MAP_LIMITS.yStart;
        if (newViewBoxX + viewBoxWidth > MAP_LIMITS.xEnd)
          newViewBoxX = MAP_LIMITS.xEnd - viewBoxWidth;
        if (newViewBoxY + viewBoxHeight > MAP_LIMITS.yEnd)
          newViewBoxY = MAP_LIMITS.yEnd - viewBoxHeight;

        if (![newViewBoxX, newViewBoxY].some(isNaN)) {
          viewBoxX = newViewBoxX;
          viewBoxY = newViewBoxY;
          mapElement.setAttribute(
            "viewBox",
            `${viewBoxX} ${viewBoxY} ${viewBoxWidth} ${viewBoxHeight}`,
          );
        }
      } else if (event.touches.length === 2) {
        // Two touches - pinch zoom
        event.preventDefault();
        const currentDistance = getDistance(
          event.touches[0].clientX,
          event.touches[0].clientY,
          event.touches[1].clientX,
          event.touches[1].clientY,
        );

        if (initialDistance && initialViewBox) {
          const scale = initialDistance / currentDistance;
          const [x, y, width, height] = initialViewBox;

          // Calculate center point between the two fingers
          const centerX =
            (event.touches[0].clientX + event.touches[1].clientX) / 2;
          const centerY =
            (event.touches[0].clientY + event.touches[1].clientY) / 2;

          const pt = new DOMPoint(centerX, centerY);
          const svgPoint = pt.matrixTransform(
            mapElement.getScreenCTM().inverse(),
          );

          const [xPropW, yPropH] = [
            (svgPoint.x - x) / width,
            (svgPoint.y - y) / height,
          ];

          const [width2, height2] = [width * scale, height * scale];

          // Don't zoom beyond limits
          if (width2 <= MAP_LIMITS.minZoom || width2 >= MAP_LIMITS.maxZoom)
            return;

          let x2 = svgPoint.x - xPropW * width2;
          let y2 = svgPoint.y - yPropH * height2;

          // Boundary checks (same as mouse version)
          if (x2 < MAP_LIMITS.xStart) x2 = MAP_LIMITS.xStart;
          if (y2 < MAP_LIMITS.yStart) y2 = MAP_LIMITS.yStart;
          if (x2 + width2 > MAP_LIMITS.xEnd) x2 = MAP_LIMITS.xEnd - width2;
          if (y2 + height2 > MAP_LIMITS.yEnd) y2 = MAP_LIMITS.yEnd - height2;

          if (![x2, y2, width2, height2].some(isNaN)) {
            viewBoxX = x2;
            viewBoxY = y2;
            viewBoxWidth = width2;
            viewBoxHeight = height2;
            mapElement.setAttribute(
              "viewBox",
              `${x2} ${y2} ${width2} ${height2}`,
            );
          }
        }
      }
    }

    function handleTouchEnd(event) {
      if (event.touches.length === 0) {
        // All touches ended
        mapElement.classList.remove("moving");
        isMapBeingDragged = false;
        initialDistance = null;
        initialViewBox = null;
      } else if (event.touches.length === 1) {
        // One touch ended but another remains
        isMapBeingDragged = false;
        initialDistance = null;
        initialViewBox = null;
      }
    }

    function handleTouchCancel() {
      mapElement.classList.remove("moving");
      isMapBeingDragged = false;
      initialDistance = null;
      initialViewBox = null;
    }

    // Helper function to calculate distance between two points
    function getDistance(x1, y1, x2, y2) {
      return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
    }

    // Add touch event listeners
    mapElement.addEventListener("touchstart", handleTouchStart, {
      passive: false,
    });
    mapElement.addEventListener("touchmove", handleTouchMove, {
      passive: false,
    });
    mapElement.addEventListener("touchend", handleTouchEnd);
    mapElement.addEventListener("touchcancel", handleTouchCancel);

    // Add touch support for country hover/click
    document.addEventListener("touchstart", (ev) => {
      if (!countries.includes(ev.target) || isMapBeingDragged) {
        countryNameElement.innerText = "";
        countryNameElement.style.display = "none";
        return;
      }

      // Show country name on touch
      let country = new Country();
      const countryName =
        ev.target.getAttribute("name") ?? ev.target.getAttribute("class");
      const countryId = ev.target.getAttribute("id");

      if (countriesCache.has(countryName)) {
        country = countriesCache.get(countryName);
      } else {
        countriesCache.set(
          countryName,
          new Country({
            name: countryName,
            id: countryId,
          }),
        );
        getCountryInformation(countryName);
      }

      if (!selectedCountry) {
        countryNameElement.style.display = "block";
        countryNameElement.innerText = country.name;

        const touch = ev.touches[0];
        const coords = calculateBoxPosition(
          touch.clientX,
          touch.clientY,
          mapElement,
        );

        countryNameElement.style.top = coords.top;
        countryNameElement.style.right = coords.right;
        countryNameElement.style.bottom = coords.bottom;
        countryNameElement.style.left = coords.left;
      }
    });

    document.addEventListener("touchend", (ev) => {
      if (ev.touches.length > 0 || isMapBeingDragged) return;

      const touch = ev.changedTouches[0];
      const target = document.elementFromPoint(touch.clientX, touch.clientY);

      if (
        (!countries.includes(target) &&
          !$("[data-global-region]").get().includes(target)) ||
        isMapBeingDragged
      ) {
        selectedCountry = null;
        selectedCountryElement.style.display = "none";
        selectedCountryElement.innerHTML = "";
        return;
      } else if (
        (countries.includes(target) ||
          $("[data-global-region]").get().includes(target)) &&
        !isMapBeingDragged
      ) {
        const countryName =
          target.getAttribute("name") ?? target.getAttribute("class");
        if (!countriesCache.has(countryName)) return;
        selectedCountry = countriesCache.get(countryName);

        const winWidth = $(window).width();

        selectedCountryElement.style.display = "block";
        selectedCountryElement.style.position =
          winWidth < 767 ? "absolute" : "fixed";

        const coords = calculateBoxPosition(
          touch.clientX,
          touch.clientY,
          mapElement,
        );
        selectedCountryElement.style.top = winWidth < 767 ? "auto" : coords.top;
        selectedCountryElement.style.right =
          winWidth < 767 ? "auto" : coords.right;
        selectedCountryElement.style.bottom =
          winWidth < 767 ? "76px" : coords.bottom;
        selectedCountryElement.style.left =
          winWidth < 767 ? "16px" : coords.left;

        renderPopup(selectedCountry, countries);
      }
    });

    /** ================== END Touch screens ========================= */

    /** ================= Map References box ==================== */

    $("[data-references-box-toggle-btn]").on("click", function (ev) {
      $("[data-references-box-close-icon]").toggleClass("hidden");
      $("[data-references-box-open-icon]").toggleClass("hidden");
      $("#references-box").toggleClass("active");
    });

    /** ================= Global regions info ==================== */
    $("[data-global-region]").on("mouseenter", function (ev) {
      const countryName = ev.target.getAttribute("name");
      const countryId = ev.target.getAttribute("id");

      // Show country name on hover and fetch data if not in cache
      if (!countriesCache.has(countryName)) {
        countriesCache.set(
          countryName,
          new Country({
            name: countryName,
            id: countryId,
          }),
        );
        getCountryInformation(countryName);
      }
    });

    const knownRegionsCoordinates = new Map([
      ["Africa", "252 95 404 173"],
      ["Asia", "428 8 346 148"],
      ["EU", "321 12 246 105"],
      ["Europe", "321 12 246 105"],
      ["Global", "50 -45 796 342"],
      ["North America", "34 0 327 140"],
      ["Oceania", "581 194 298 127"],
      ["South America", "90 170 351 150"],
    ]);

    $("[data-global-region]").click(function (ev) {
      $("[data-global-region]").removeClass("active");
      $(this).addClass("active");

      const countryName = ev.target.getAttribute("name");
      if (!countriesCache.has(countryName)) return;
      selectedCountry = countriesCache.get(countryName);
      const regionCoords = knownRegionsCoordinates.get(countryName);

      selectedCountryElement.style.display = "block";
      selectedCountryElement.style.position = "absolute";
      selectedCountryElement.style.top = "auto";
      selectedCountryElement.style.right = "auto";
      selectedCountryElement.style.bottom = "50%";
      selectedCountryElement.style.left = "50%";
      selectedCountryElement.style.transform = "translate(-50%, 50%)";

      if (!!regionCoords) {
        const splitCoords = regionCoords.split(" ");
        viewBoxX = splitCoords[0];
        viewBoxY = splitCoords[1];
        viewBoxWidth = splitCoords[2];
        viewBoxHeight = splitCoords[3];
        mapElement.setAttribute("viewBox", regionCoords);
      }

      renderPopup(selectedCountry, countries);
    });
  }

  function calculateBoxPosition(mouseX, mouseY, mapContainer) {
    const mapRect = mapContainer.getBoundingClientRect();
    const tagWidth = 120;
    const tagHeight = 50;

    // Calculate the mouse position relative to the map container
    const relativeX = mouseX - mapRect.left;
    const relativeY = mouseY - mapRect.top;

    const coords = {
      top: "auto",
      right: "auto",
      bottom: "auto",
      left: "auto",
    };

    // Check if the pointer is in the top or bottom half of the map container
    if (relativeY < mapRect.height / 2) {
      // Top half
      coords.top = `${relativeY + 10}px`;
      coords.bottom = "auto";
    } else {
      // Bottom half
      coords.bottom = `${mapRect.height - relativeY + 10}px`;
      coords.top = "auto";
    }

    // Check if the pointer is in the left or right half of the map container
    if (relativeX < mapRect.width / 2) {
      // Left half
      coords.left = `${relativeX + 10}px`;
      coords.right = "auto";
    } else {
      // Right half
      coords.right = `${mapRect.width - relativeX + 10}px`;
      coords.left = "auto";
    }

    // Ensure the tag doesn't go off-screen
    if (
      coords.top !== "auto" &&
      parseInt(coords.top) + tagHeight > mapRect.height
    ) {
      coords.top = "auto";
      coords.bottom = `${mapRect.height - relativeY + 10}px`;
    }
    if (
      coords.bottom !== "auto" &&
      parseInt(coords.bottom) + tagHeight > mapRect.height
    ) {
      coords.bottom = "auto";
      coords.top = `${relativeY - tagHeight - 10}px`;
    }
    if (
      coords.left !== "auto" &&
      parseInt(coords.left) + tagWidth > mapRect.width
    ) {
      coords.left = "auto";
      coords.right = `${mapRect.width - relativeX + 10}px`;
    }
    if (
      coords.right !== "auto" &&
      parseInt(coords.right) + tagWidth > mapRect.width
    ) {
      coords.right = "auto";
      coords.left = `${relativeX - tagWidth - 10}px`;
    }

    return coords;
  }

  // ============================= Main actions ============================= //

  (() => {
    const mapElement = document.querySelector("#world-map > svg");
    const countries = [...document.querySelectorAll("#world-map > svg path")];

    if (mapElement) makeMapInteractive(mapElement, countries);

    document.addEventListener(DATA_RECEIVED_EVENT_KEY, (ev) => {
      if (
        !countriesCache.has(ev.detail?.countryName) ||
        !selectedCountry ||
        ev.detail?.countryName !== selectedCountry.name
      )
        return;
      const country = countriesCache.get(ev.detail.countryName);

      // UPDATE POPUP
      renderPopup(selectedCountry, countries);
    });
  })();
})(jQuery);
